import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import styles from '../../../../../styles/transitionplan.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useMessageStore from "../../../../../stores/message-store";
import useApi from "../../../../../hooks/use-api";
import { DualObjectToStringRepresentation, EmptyStringToNull, NullableInputToEmptyString } from "../../../../../utilities/rhfdatanormalizationfunctions";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import FormInputValidationMessage from "../../../../../components/forminputvalidationmessage";

const Procard = ({ApplicationID,Procards = [],RequestedBy = [],RequestedByAlternatives = [],UserMasterList = [],Additional = [],addProcard,updateProcard}) => {
    // const [showAdditionalField,setShowAdditionalField] = useState(false);
    // const [isLoading,setIsLoading] = useState(false);

    const [requestByList,setRequestByList] = useState(RequestedBy);
    const [releasedToList,setReleasedToList] = useState(RequestedBy);

    const initialValues = {
        id: 0,
        requesteddate: '',
        requestedby: '',
        receiveddate: '',
        procardnumber: '',
        releaseddate: '',
        releasedto: '',
        returnedtotcdate: '',
        returnedtoafmdate: '',
        additionalreason: '',
        additionalreasonother: '',
        comments: '',

        // requesteddate: null,
        // issuedto: -1,
        // number: null,
        // receiveddate: null,
        // releaseddate: null,
        // releasedto: -1,
        // returneddate: null,
        // additionaltype: null,
        // additionaltypeother: null,
        // comments: null
    }

    const {postRequest,putRequest} = useApi();

    const _NormalizeForm = (rawPCData) => {
        const {id,requestedby,requestedbyalternative,releasedto,releasedtoalternative,...Values} = rawPCData;

        const resetData = Object.fromEntries(
            Object.entries(Values).map(([key,value]) => [key,NullableInputToEmptyString(value)])
        );

        const resetValues = {
            id: id,
            ...resetData,
            requestedby: DualObjectToStringRepresentation(requestedby,requestedbyalternative),
            releasedto: DualObjectToStringRepresentation(releasedto,releasedtoalternative)
        }

        return resetValues;
    }

    const [selectedProcard,setSelectedProcard] = useState(() => Procards.length > 0 ? Procards[Procards.length - 1] : null);

    const validationSchema = Yup.object().shape({
        requesteddate: Yup.string().required('*Required'),
        requestedby: Yup.string().required('*Required')
    });

    const enhancedSchema = Yup.object().shape({
        requesteddate: Yup.string().required('*Required'),
        requestedby: Yup.string().required('*Required'),
        additionalreason: Yup.string().required('*Required'),
        additionalreasonother: Yup.string().when('additionalreason',{
            is: (val) => Additional.find(item => `${item.id}` === val)?.hasfollowup,
            then: (schema) => schema.required("*Required"),
            otherwise: (schema) => schema.notRequired()
        })
    });

    const schema = useMemo(() => {
        const procardindex = selectedProcard 
        ? 
            Procards.findIndex(pc => pc.id === selectedProcard.id) 
        : 
            Procards.length

        if(procardindex === 0){
            return validationSchema;
        }
        else{
            return enhancedSchema;
        }
    },[selectedProcard,Procards])

    const {register,watch,handleSubmit,reset,resetField,setValue,formState: {isDirty,isSubmitting,errors}} = useForm({resolver: yupResolver(schema),defaultValues: initialValues});

    const addClick = () => {
        setSelectedProcard(null);
        // reset(initialValues);
    }

    const selectClick = (pc) => {
        setSelectedProcard(pc);

        // const {id,requestedby,requestedbyalternative,releasedto,releasedtoalternative,...Values} = pc;

        // const resetData = Object.fromEntries(
        //     Object.entries(Values).map(([key,value]) => [key,NullableInputToEmptyString(value)])
        // );

        // const resetValues = {
        //     id: id,
        //     ...resetData,
        //     requestedby: DualObjectToStringRepresentation(requestedby,requestedbyalternative),
        //     releasedto: DualObjectToStringRepresentation(releasedto,releasedtoalternative)
        // }

        // reset(resetValues);

        // const resetValues = _NormalizeForm(pc);

        // reset(resetValues);
    }

    useEffect(() => {
        if(selectedProcard){
            reset(_NormalizeForm(selectedProcard));

            setRequestByList(RequestedBy);
            setReleasedToList(RequestedBy);

            if(selectedProcard.requestedby !== null){
                if(!RequestedBy.find(item => item.id === selectedProcard.requestedby)){
                    //Not found in primary list
                    const masterRef = UserMasterList.find(item => item.id === selectedProcard.requestedby);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }
                    setRequestByList([inactiveItem,...RequestedBy]);
                }
            }

            if(selectedProcard.releasedto !== null){
                if(!RequestedBy.find(item => item.id === selectedProcard.releasedto)){
                    //Not found in primary list
                    const masterRef = UserMasterList.find(item => item.id === selectedProcard.releasedto);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }

                    setReleasedToList([inactiveItem,...RequestedBy]);
                }
            }
        }
        else{
            reset(initialValues);

            setRequestByList(RequestedBy);
            setReleasedToList(RequestedBy);
        }
    },[selectedProcard,reset])

    const processRequestedByField = (reqString) => {
        let result = { requestedby: null, requestedbyalternative: null };
    
        if (reqString === '') {
          return result;
        }
    
        const reqValue = parseInt(reqString);
    
        if (reqValue < 0) {
          result.requestedbyalternative = Math.abs(reqValue);
        } else {
          result.requestedby = reqValue;
        }
    
        return result;
    }

    const processReleasedToField = (relString) => {
        let result = { releasedto: null, releasedtoalternative: null };
    
        if (relString === '') {
          return result;
        }
    
        const relValue = parseInt(relString);
    
        if (relValue < 0) {
          result.releasedtoalternative = Math.abs(relValue);
        } else {
          result.releasedto = relValue;
        }
    
        return result;
    }

    const prepareDataForSend = (data) => {
        const transformedObj = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                transformedObj[key] = EmptyStringToNull(data[key]);
            }
        }
        
        return transformedObj;
    
    }

    const _handleSubmit = async (items) => {
       const {requestedby,releasedto,...restData} = items;

       const processReqField = processRequestedByField(requestedby);
       const processedRelField = processReleasedToField(releasedto);

       const submitData = {
        ...restData,
        ...processReqField,
        ...processedRelField
       }

       const finalData = prepareDataForSend(submitData);

       if(finalData.additionalreason === null || !Additional.find(item => item.id === finalData.additionalreason).hasfollowup){
        finalData.additionalreasonother = null;
       }

       if(!selectedProcard){
        const [data,status] = await postRequest('TransitionChecklist_Procard_Add',{ApplicationID: ApplicationID,...finalData});

        if(status === 201){
            addProcard(data.procard);
            setSelectedProcard(data.procard);

            addToast(
                {
                    id: Math.random(),
                    body: "The Procard was succesfully added!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when adding the Procard.",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )
        }
       }
       else{
        const [data,status] = await putRequest('TransitionChecklist_Procard_Update',{...finalData});

        if(status === 200){
            updateProcard(data);

            reset(_NormalizeForm(data));

            setSelectedProcard(data);

            addToast(
                {
                    id: Math.random(),
                    body: "The Procard was succesfully updated!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when updating the Procard.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            )
        }
       }


    }

    const additionalfield = watch('additionalreason');
    const requestedby = watch('requestedby');
    const releasedto = watch('releasedto');

    const showField = additionalfield
        ?
            additionalfield !== ''
            ?
                Additional.find(option => option.id === additionalfield).hasfollowup
            :
                false
        :
            false
    const procardindex = selectedProcard 
        ? 
            Procards.findIndex(pc => pc.id === selectedProcard.id) 
        : 
            Procards.length

    useEffect(() => {
        if(!selectedProcard){
            if(!showField){
                resetField('additionalreason');

                setValue('additionalreasonother',initialValues.additionalreasonother);
            }
        }
    },[showField,selectedProcard])

    const addToast = useMessageStore(state => state.addToast);

    const requestedbyerror =  requestedby !== ''
    ?
        parseInt(requestedby) > 0
        ?
            requestByList.find(item => item.id === parseInt(requestedby)).Inactive
        :
            false
    :
        false

    const releasedtoerror =  releasedto !== ''
    ?
        parseInt(releasedto) > 0
        ?
            releasedToList.find(item => item.id === parseInt(releasedto)).Inactive
        :
            false
    :
        false

    // console.log(errors);
    
    return(
        <>
            <h6 className="fw-bold ">Procard Information</h6>
            <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                <Row>
                    <Col xs={12}>
                        <div className={styles.proCardOuterBox}>
                            <div className={styles.proCardBox}>
                                {
                                    Procards.map((pc) => (
                                        <button disabled={isSubmitting} key={pc.id} type="button" title={`Select Procard : ${pc.requesteddate}`} aria-label={`Select Procard : ${pc.requesteddate}`} className={`${styles.proCardItem} ${selectedProcard?.id === pc.id ? styles.active : null}`} onClick={() => selectClick(pc)}>
                                        {
                                            pc.requesteddate
                                        }
                                        </button>
                                    ))
                                }
                                {
                                    selectedProcard
                                    &&
                                        <Button disabled={isSubmitting} type="button" variant="success" size="sm" className={styles.addProcardBtn} title="New Procard" aria-label="New Procard" onClick={addClick}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <strong>Request Information</strong>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <label htmlFor="requesteddate">Procard Requested Date</label>
                        <input disabled={isSubmitting} {...register('requesteddate')} id="requesteddate" type="date" style={{width: '100%',height: '30px'}}/>
                        <FormInputValidationMessage error={errors?.requesteddate} />
                    </Col>
                    <Col xs={12} md={6} lg={8}>
                        <label htmlFor="requestedby">Procard Requested By</label>
                        <select disabled={isSubmitting} {...register('requestedby')} id="requestedby" style={{width: '100%', height: '30px',color: requestedbyerror ? 'red' : 'black'}}>
                            <option value='' style={{color: 'black'}}>--Make a selection--</option>
                            {
                                RequestedByAlternatives.map((item) => (
                                    <option style={{color: 'black'}} key={item.id} value={`-${item.id}`}>{item.name}</option>
                                ))
                            }
                            {
                                requestByList.map((item) => (
                                    <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                ))
                            }
                            {/* {
                                RequestedBy.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))
                            } */}
                        </select>
                        <FormInputValidationMessage error={errors?.requestedby} />
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12}>
                        <strong>Received Information</strong>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <label htmlFor="receiveddate">Procard Received Date</label>
                        <input disabled={isSubmitting} {...register('receiveddate')} id="receiveddate" type="date" style={{width: '100%',height: '30px'}}/>
                    </Col>
                    <Col xs={12} md={6} lg={8}>
                        <label htmlFor="procardnumber">Procard Number</label>
                        <input disabled={isSubmitting} {...register('procardnumber')} type="text" id="procardnumber" style={{width: '100%',height: '30px'}}/>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12}>
                        <strong>Released Information</strong>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <label htmlFor="releaseddate">Procard Released Date</label>
                        <input disabled={isSubmitting} {...register('releaseddate')} id="releaseddate" type="date" style={{width: '100%',height: '30px'}}/>
                    </Col>
                    <Col xs={12} md={6} lg={8}>
                        <label htmlFor="releasedto">Procard Released To</label>
                        <select disabled={isSubmitting} {...register('releasedto')} id="releasedto" style={{width: '100%', height: '30px',color: releasedtoerror ? 'red' : 'black'}}>
                            <option value='' style={{color: 'black'}}>--Make a selection--</option>
                            {
                                RequestedByAlternatives.map((item) => (
                                    <option style={{color: 'black'}} key={item.id} value={`-${item.id}`}>{item.name}</option>
                                ))
                            }
                            {
                                releasedToList.map((item) => (
                                    <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                ))
                            }
                        </select>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12}>
                        <strong>Returned Information</strong>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <label htmlFor="returnedtotcdate">Procard Returned to TC Date</label>
                        <input disabled={isSubmitting} {...register('returnedtotcdate')} id="returnedtotcdate" type="date" style={{width: '100%',height: '30px'}}/>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <label htmlFor="returnedtoafmdate">Procard Returned to AFM Date</label>
                        <input disabled={isSubmitting} {...register('returnedtoafmdate')} id="returnedtoafmdate" type="date" style={{width: '100%',height: '30px'}}/>
                    </Col>
                </Row>
                {
                    procardindex !== 0
                    ?
                        <Row className="mt-2">
                            <Col xs={12}>
                                <strong>Additional Information</strong>
                            </Col>
                            <Col xs={12} md={6} lg={4}>
                                <label htmlFor="additionalreason">Additional Reason</label>
                                <select disabled={isSubmitting} style={{width: '100%', height: '30px'}} {...register('additionalreason')} id="additionalreason">
                                    <option value="">--Make Selection--</option>
                                    {
                                        Additional.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                                <FormInputValidationMessage error={errors?.additionalreason} />
                            </Col>
                            {
                                showField
                                ?
                                    <Col xs={12} md={6} lg={8}>
                                        <label htmlFor="additionalreasonother">Additional Reason Other</label>
                                        <input disabled={isSubmitting} type="text" id="additionalreasonother" {...register('additionalreasonother')} style={{width: '100%',height: '30px'}} />
                                        <FormInputValidationMessage error={errors?.additionalreasonother} />
                                    </Col>
                                :
                                    null
                            }
                        </Row>       
                    :
                        null
                }
                <Row className="mt-2">
                    <Col xs={12}>
                        <label htmlFor="comments">Procard Comments</label>
                        <textarea disabled={isSubmitting} {...register('comments')} rows={4} id="comments" style={{width: '100%'}} />
                    </Col>
                </Row>
                <Row className="mt-2 mb-1">
                    <Col xs={12}>
                        <div className="d-flex justify-content-end align-items-center">
                            {
                                selectedProcard
                                ?
                                    <Button type="submit" variant="primary" onClick={handleSubmit(_handleSubmit)} disabled={!isDirty || isSubmitting}>
                                        {
                                            isSubmitting
                                            ?
                                                <Spinner animation='border' size='sm' />
                                            :
                                                <>Save Changes</>
                                        }
                                    </Button>
                                :
                                    <Button type="submit" variant="success" onClick={handleSubmit(_handleSubmit)} disabled={!isDirty || isSubmitting}>
                                        {
                                            isSubmitting
                                            ?
                                                <Spinner animation="border" size="sm" />
                                            :
                                                <>
                                                    <FontAwesomeIcon icon={faPlus} size="xl" className="me-1"/>
                                                    Add Procard
                                                </>
                                        }
                                    </Button>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Procard;